<template>
    <b-row v-if="regiones">
        <b-col cols="12" class="text-right">
            <b-button
                @click="guardarPrecios(regiones)"
            >
                Guardar todos
            </b-button>
        </b-col>
        <b-col cols="12" v-for="region in regiones" v-bind:key="region.id">
            <b-row>
                <b-col md="10" col="5">
                    <b-form-group
                        :id="'label-region-' + region.id"
                        :label="region.name"
                        :label-for="'region-' + region.id"
                    >
                        <multiselect
                            :id="'region-' + region.id"                
                            v-model="region.precios"
                            placeholder="Precios onilne"
                            label="description"
                            track-by="id"
                            :options="precios"
                            :multiple="true"
                        />
                    </b-form-group>   
                </b-col>
                <b-col md="2" col="5" class="text-right mt-2">
                    <b-button 
                        class="mt-4"
                        @click="guardarPrecios([region])"
                    >
                        Guardar
                    </b-button>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        props: ['pack_id', 'precios'],
        data() {
            return {
                regiones: null,
            }
        },
        created() {
            this.getRegiones();
        },
        methods: {
            getRegiones() {
                const params = {
                    filters : {},
                    pack_id: this.pack_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.packs-events.show.regions'), params).then(res => {
                    this.regiones = res.data.data;
                });
            },
            guardarPrecios(regiones) {
                let data = {
                    filters: {},
                    regiones: regiones,
                    pack_id: this.pack_id
                }
                this.$store.dispatch(this.config.getVuexAlias('back.teatro.packs-events.show.regions.precios'), data).then(res => {
                    this.$toast.success(res.data.message);
                    this.getRegiones();
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                });
            }
        }
    }
</script>